import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgClient() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M1.03 16.84a5.5 5.5 0 013.77-5.22.44.44 0 00.09-.78 3 3 0 010-4.9M22.968 16.84a5.5 5.5 0 00-3.77-5.22.44.44 0 01-.09-.78 3 3 0 000-4.9",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M12 12a4 4 0 100-8 4 4 0 000 8z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }, void 0), _jsx("path", {
      d: "M4 20a8 8 0 0116 0H4z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
}

export default SvgClient;